import { gql } from '@apollo/client';

export const CREATE_CONSUMER_MUTATION = gql`
  mutation CreateConsumer($consumerCreateDto: ConsumerCreateDto!) {
    createConsumer(consumerCreateDto: $consumerCreateDto) {
      id
      institutionName
      email
      createdDt
    }
  }
`;
